module.exports = __webpack_public_path__ + "img/pl.607e4f68.svg";